import script from "./ElementMaterials.vue?vue&type=script&setup=true&lang=js"
export * from "./ElementMaterials.vue?vue&type=script&setup=true&lang=js"

import "./ElementMaterials.vue?vue&type=style&index=0&id=db55750a&lang=scss&scoped=true"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/3d-editor-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db55750a"]])

export default __exports__